import * as React from 'react';
import {getMeta, TypeImplementation} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import {ButtonGroup} from '@packages/systems/design-system/ButtonGroup';

import {TBoolean, EBoolean} from '@packages/systems/wfdl-ast';

import {
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';

export const LabeledBoolean = TypeImplementation.Alias({
  type: TBoolean,
  render: ({expr, dispatch}) => {
    const bool = ContextualExpressions.getBoolean(stripAnn(expr));
    if (bool !== null) {
      const type = getAnn(expr).type;
      // Without a type we can't have meta and thus no labels, which we need
      if (!type) return null;
      const meta = getMeta(type);
      const labels = meta && meta.labels;
      if (!labels) return null;
      const values = {
        true: labels['true'] || '',
        false: labels['false'] || '',
      } as const;

      const onChange = (value: string) => {
        const newValue = EBoolean(value === 'true');
        dispatch(updateExpressionAction(newValue));
      };

      return (
        <ButtonGroup
          data-automation-id="LabeledBooleanAlias"
          value={String(bool)}
          onChange={onChange}
          options={Object.keys(values).map((value) => ({
            value,
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly true: any; readonly false: any; }'.
            label: values[value] || value,
          }))}
        />
      );
    }
    return <ExpressionEditor expression={expr} dispatch={dispatch} />;
  },
});
